/* ===== AEMAI Motion System v2 (2026-10) =====
   - 6 种入场变体按元素类型分配（卡片=scale / 图片格=clip / 列表=交替 slide / 区块=rise / 页脚=fade）
   - 卡片加青色扫描线；标题扫入；数字 count-up + 发光
   - 只挂首屏以下元素（防闪烁、保 LCP）；reduced-motion 直接退出 */
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var d = document;
  var vh = window.innerHeight || 800;
  var tagged = new WeakSet();

  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

  function tag(el, variant, scan, delay) {
    if (!el || tagged.has(el)) return;
    var r = el.getBoundingClientRect();
    if (r.height === 0 || r.top <= vh * 0.92) return;   /* 首屏内：不动 */
    tagged.add(el);
    el.classList.add('aemai-reveal');
    el.setAttribute('data-reveal', variant);
    el.setAttribute('data-reveal-delay', String(delay % 4));
    if (scan) el.classList.add('aemai-scanline');
    revealIO.observe(el);
  }

  /* ---- 分组：选择器 -> 入场变体 ---- */
  var GROUPS = [
    { sel: '.aemai-fp-img-grid-item, .aemai-cert-tm-card', v: 'clip' },
    { sel: '.aemai-pdp-reading-card', v: 'scale', scan: true },
    { sel: '.aemai-collection-card, .aemai-daily-card, .aemai-trust-card, .aemai-craft, .aemai-team-card, .aemai-factory-stat-card, .aemai-fp-cap-card, .aemai-ip-tech-card, .aemai-product-card, .aemai-news-card, .aemai-blog-card, .card-wrapper, .grid__item', v: 'scale', scan: true },
    { sel: '.aemai-timeline-item, .aemai-fp-stat-item, .aemai-ip-process-step, .aemai-value-item, .aemai-faq-item', v: 'alt' },
    { sel: '.aemai-ft-col', v: 'fade' },
    { sel: '.aemai-distributor, .aemai-ft-news, .aemai-ft-bottom, .aemai-collection-header, .aemai-cert-reports, .aemai-cert-patents, .aemai-cert-tm-grid, .aemai-cert-tm-tablewrap, .aemai-footer-cert, .aemai-stats-eyebrow, .aemai-fp-stat-bar, .aemai-fp-img-grid', v: 'rise' },
    { sel: '.aemai-factory-page > div, .aemai-innovation-page > div', v: 'rise' }
  ];
  GROUPS.forEach(function (g) {
    d.querySelectorAll(g.sel).forEach(function (el, i) {
      var v = g.v === 'alt' ? (i % 2 === 0 ? 'slideL' : 'slideR') : g.v;
      tag(el, v, !!g.scan, i);
    });
  });

  /* ---- 标题：青色下划线扫入 ---- */
  var sweepSel = '.aemai-cert-gallery-title, .aemai-cert-reports-title, .aemai-cert-patents-title, .aemai-cert-trademarks-title, .aemai-faq-title, .aemai-stats-eyebrow, .aemai-fp-section-title, .aemai-ip-section-title';
  var sweepIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); sweepIO.unobserve(e.target); } });
  }, { threshold: 0.2 });
  d.querySelectorAll(sweepSel).forEach(function (el) {
    el.classList.add('aemai-sweep');
    if (el.getBoundingClientRect().top > vh * 0.92) sweepIO.observe(el); else el.classList.add('is-visible');
  });

  /* ---- 数字 count-up + 落位发光 ---- */
  function run(el, target, pre, suf) {
    var dur = 1100, t0 = null;
    function tick(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(target * e) + suf;
      if (p < 1) requestAnimationFrame(tick); else el.textContent = pre + target + suf;
    }
    requestAnimationFrame(tick);
  }
  var countIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        countIO.unobserve(e.target);
        var m = (e.target.dataset.aemaiCount || '').split('|');
        e.target.classList.add('is-visible');
        run(e.target, parseInt(m[0], 10), m[1] || '', m[2] || '');
      }
    });
  }, { threshold: 0.4 });
  d.querySelectorAll('.aemai-stat-number, .aemai-fp-stat-item strong, .aemai-factory-stat-card strong').forEach(function (el) {
    var t = (el.textContent || '').trim();
    var m = t.match(/^([^\d]*?)(\d[\d,]*)(.*)$/);
    if (!m) return;
    var num = parseInt(m[2].replace(/,/g, ''), 10);
    if (!num || num < 2) return;
    el.dataset.aemaiCount = num + '|' + m[1] + '|' + m[3];
    el.textContent = m[1] + '0' + m[3];
    countIO.observe(el);
  });

  /* ---- 懒加载图片淡入（安全） ---- */
  d.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.complete || img.getBoundingClientRect().top <= vh) return;
    img.style.opacity = '0'; img.style.transition = 'opacity .5s ease';
    var show = function () { img.style.opacity = '1'; };
    img.addEventListener('load', show); img.addEventListener('error', show);
    setTimeout(show, 6000);
  });
})();
